/**
THEME constants
*/
export const UPDATE_THEME_TYPE = 'mumms.themeTypeChanged';
export const THEME = 'mumms.theme';
export const lightTheme = 'light';
export const darkTheme = 'dark';
export const iceTheme = 'ice';
export const blueberryTheme = 'blueberry';
export const defaultTheme = iceTheme;
/**
WIDGET constants
*/

export const NUM_OPEN_WIDGET = 'numOpenWidgets';
export const PATIENT_HEADER_HEIGHT = 'patientHeaderHeight';